import React from 'react';

/** Building icon with plus badge (matches GroupsAddGroupEmptyState pattern). */
function OrganizationAddIcon() {
  return (
    <>
      <svg
        className="groups-add-group-empty__users"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
        <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
        <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
        <path d="M10 6h4" />
        <path d="M10 10h4" />
        <path d="M10 14h4" />
        <path d="M10 18h4" />
      </svg>
      <span className="groups-add-group-empty__icon-plus" aria-hidden>
        +
      </span>
    </>
  );
}

/**
 * Empty organizations list — dashed card in the list area (no floating FAB).
 */
const GroupsAddOrganizationEmptyState = ({
  onClick,
  disabled = false,
  className = '',
  label = 'Add an organization'
}) => {
  const interactive = Boolean(onClick) && !disabled;
  const Tag = interactive ? 'button' : 'div';

  return (
    <Tag
      type={interactive ? 'button' : undefined}
      className={[
        'groups-add-group-empty',
        interactive ? 'groups-add-group-empty--interactive' : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={interactive ? onClick : undefined}
      disabled={Tag === 'button' ? disabled : undefined}
      aria-label={interactive ? label : undefined}
      title={interactive ? label : undefined}
    >
      <span className="groups-add-group-empty__icon" aria-hidden>
        <OrganizationAddIcon />
      </span>
      <span className="groups-add-group-empty__label">{label}</span>
    </Tag>
  );
};

export default GroupsAddOrganizationEmptyState;
